(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gs-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gs-navigation')) {
    customElements.define('gs-navigation', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.abort = new AbortController();
        this.hoverCleanup = [];
        const signal = this.abort.signal;
        const disclosures = [...this.querySelectorAll('.gs-nav__disclosure')];
        const close = (except) => disclosures.forEach(item => { if (item !== except) item.open = false; });
        disclosures.forEach(item => {
          item.addEventListener('toggle', () => { if (item.open) close(item); }, { signal });
        });
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          this.hoverCleanup.forEach(cancel => cancel());
          const current = event.target.closest('details[open]');
          if (current && this.contains(current)) {
            event.preventDefault();
            event.stopPropagation();
            current.open = false;
            current.querySelector('summary').focus();
          }
        }, { signal });
        if (this.dataset.mode === 'desktop') {
          document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) close(); }, { signal });
          this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) close(); }, { signal });
          disclosures.forEach(item => {
            let enterTimer;
            let leaveTimer;
            this.hoverCleanup.push(() => { clearTimeout(enterTimer); clearTimeout(leaveTimer); });
            item.addEventListener('pointerdown', () => { clearTimeout(enterTimer); clearTimeout(leaveTimer); }, { signal });
            item.addEventListener('pointerenter', event => {
              if (event.pointerType !== 'mouse') return;
              clearTimeout(leaveTimer);
              enterTimer = setTimeout(() => { close(item); item.open = true; }, 180);
            }, { signal });
            item.addEventListener('pointerleave', event => {
              if (event.pointerType !== 'mouse') return;
              clearTimeout(enterTimer);
              leaveTimer = setTimeout(() => { if (!item.contains(document.activeElement)) item.open = false; }, 220);
            }, { signal });
          });
        } else {
          const header = this.closest('m-header');
          const drawer = this.closest('.m-menu-drawer');
          const toggle = header.querySelector('.m-hamburger-box');
          const sync = () => {
            const open = drawer.classList.contains('open');
            toggle.setAttribute('aria-expanded', String(open));
            toggle.setAttribute('aria-label', open ? this.querySelector('nav').dataset.closeLabel : this.querySelector('nav').dataset.openLabel);
            drawer.inert = !open;
          };
          this.observer = new MutationObserver(sync);
          this.observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
          sync();
          const desktop = matchMedia('(min-width: 1024px)');
          desktop.addEventListener('change', event => {
            if (event.matches && drawer.classList.contains('open')) header.megamenu.closeMenu();
          }, { signal });
          header.addEventListener('keydown', event => {
            if (!drawer.classList.contains('open')) return;
            if (event.key === 'Escape') {
              event.preventDefault();
              header.megamenu.closeMenu();
              toggle.focus();
            }
            if (event.key === 'Tab') {
              const nodes = [toggle, ...drawer.querySelectorAll('a[href], button, summary, select, input')].filter(node => {
                if (!node.getClientRects().length || node.disabled || getComputedStyle(node).visibility === 'hidden') return false;
                for (let parent = node.parentElement; parent && parent !== header; parent = parent.parentElement) {
                  if (parent.matches('details:not([open])') && !parent.querySelector(':scope > summary').contains(node)) return false;
                }
                return true;
              });
              const index = nodes.indexOf(document.activeElement);
              const next = (index + (event.shiftKey ? -1 : 1) + nodes.length) % nodes.length;
              event.preventDefault();
              nodes[next].focus();
            }
          }, { signal });
        }
      }
      disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.hoverCleanup?.forEach(cancel => cancel()); this.ready = false; }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gs-sample-shopping"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gs-sample-shopping')) {
    customElements.define('gs-sample-shopping', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const form = this.querySelector('[data-gs-sample-form]');
        if (!form) return;
        const choices = [...form.querySelectorAll('input[name="sample_finish"]')];
        const submit = form.querySelector('[data-gs-sample-submit]');
        const count = form.querySelector('[data-gs-sample-count]');
        const total = form.querySelector('[data-gs-sample-total]');
        const error = form.querySelector('[data-gs-sample-error]');
        const idleLabel = submit.textContent;
        const money = new Intl.NumberFormat(this.dataset.locale || document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency });
        let busy = false;
        const selected = () => choices.filter(input => input.checked && input.dataset.unavailable !== 'true');
        choices.forEach(input => { input.dataset.unavailable = String(input.disabled); });
        const update = () => {
          const checked = selected();
          count.textContent = this.dataset.selected.replace('__COUNT__', String(checked.length));
          total.textContent = money.format(checked.reduce((sum, input) => sum + Number(input.dataset.price), 0) / 100);
          submit.disabled = busy || !checked.length;
          submit.setAttribute('aria-disabled', String(busy || !checked.length));
        };
        form.addEventListener('change', () => { error.hidden = true; update(); });
        form.addEventListener('submit', async event => {
          event.preventDefault();
          if (busy) return;
          const checked = selected();
          if (!checked.length) return;
          busy = true;
          error.hidden = true;
          form.setAttribute('aria-busy', 'true');
          submit.textContent = this.dataset.adding;
          choices.forEach(input => { input.disabled = true; });
          update();
          let failureMessage = this.dataset.error;
          try {
            const response = await fetch(this.dataset.addUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: checked.map(input => ({ id: input.value, quantity: 1 })) })
            });
            const result = await response.json();
            if (!response.ok) {
              failureMessage = typeof result.description === 'string' ? result.description : this.dataset.error;
              throw new Error('cart-add-failed');
            }
            window.location.assign(this.dataset.cartUrl);
          } catch {
            busy = false;
            choices.forEach(input => { input.disabled = input.dataset.unavailable === 'true'; });
            form.removeAttribute('aria-busy');
            submit.textContent = idleLabel;
            error.textContent = failureMessage;
            error.hidden = false;
            update();
            error.focus();
          }
        });
        update();
        form.hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
